export async function sendMessage(principalName: string): Promise<void> {
  const response = await fetch(
    `/backend/messages/callback?name=${principalName}`
  );
  if (response.status != 201) {
    throw Error("send_message_failed");
  }
}
